
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.366 3.36a.9.9 0 011.273 1.274L9.272 7.999l3.367 3.367a.9.9 0 01.08 1.181l-.08.092a.9.9 0 01-1.273 0L8 9.272 4.634 12.64a.9.9 0 01-1.181.08l-.092-.08a.9.9 0 010-1.273L6.727 8 3.361 4.634a.9.9 0 01-.08-1.181l.08-.092a.9.9 0 011.273 0l3.365 3.366z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    